import { createReducer, on } from '@ngrx/store';
import { AuthActions } from '.';
import { AuthState } from '.';

/**
 * The initial state for the application authentication.
 *
 * isLoggedIn starts out null, since it is specified in the guards
 * to ignore null values and only take boolean values. This ensures
 * that the guards ignore the initial state and wait for the state
 * to be set, either by rehydrate or rehydrate failure.
 */
export const initialState: AuthState = {
  isLoggedIn: null,
  user: null,
  loginError: null,
};

export const authReducer = createReducer(
  initialState,
  on(
    AuthActions.loginSuccess,
    (state, { user }): AuthState => ({
      isLoggedIn: true,
      user: user,
      loginError: null,
    })
  ),
  on(
    AuthActions.loginFailure,
    (state, { error }): AuthState => ({
      isLoggedIn: false,
      user: null,
      loginError: error,
    })
  ),
  on(AuthActions.logout, (): AuthState => initialState),
  on(
    AuthActions.rehydrateSuccess,
    (state, { user }): AuthState => ({
      isLoggedIn: true,
      user: user,
      loginError: null,
    })
  ),
  on(
    AuthActions.rehydrateFailure,
    (state): AuthState => ({
      ...state,
      isLoggedIn: false,
    })
  )
);
